/* eslint-disable no-unused-vars */
import React, { useEffect, useCallback, useState } from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  Inputs, Spinner, ViewTypes, PermissionsComponent, TabsComponent
} from '../../Components';
import { ViewTypesEnum } from '../../Enums';
import { FormBuilderGridView } from './FormBuilderGridView/FormBuilderGridView';
import { FormBuilderListView } from './FormBuilderListView/FormBuilderListView';
import { GetForms } from '../../Services/formbuilder/getForms';
import { CreateForm } from '../../Services';
import { FormBuilderPermissions } from '../../Permissions';
import { returnPropsByPermissions, bottomBoxComponentUpdate } from '../../Helper';
import { AddNewFormDialog } from './Dialogs/AddNewFormDialog';
import { useTitle } from '../../Hooks';

const parentTranslationPath = 'FormBuilderView';
const translationPath = '';

const PickFormBuilder = ({ loginResponse }) => {
  const { t } = useTranslation(parentTranslationPath);
  useTitle(t('Shared:form-builder'));
  const [loading, setLoading] = React.useState(false);
  const [filter, setFilter] = React.useState({
    pageSize: 300,
    pageIndex: 0,
    searchedItem: '',
  });
  const [activeTab, setActiveTab] = useState(0);
  const [formsCategoryTabs, setFormsCategoryTabs] = useState([]);
  const [openAddNewForm, setOpenAddNewForm] = useState(false);

  const [formsResponse, setFormsResponse] = React.useState({
    result: [],
    totalCount: 0
  });
  const [activeActionType, setActiveActionType] = React.useState(ViewTypesEnum.cards.key);

  const getFormsCategories = (formsData) => {
    const formsCategories = [];

    formsData.forEach((item) => {
      if (!formsCategories.includes(item.categoryName))
        formsCategories.push(item.categoryName);
    });

    const mappedFormsCategories = formsCategories.map((item) => ({ label: item }));

    setFormsCategoryTabs(mappedFormsCategories);
    return formsCategories;
  };

  const GetMyForms = useCallback(async () => {
    setLoading(true);
    if (returnPropsByPermissions(FormBuilderPermissions.ViewFormBuilder.permissionsId)) {
      const res = await GetForms(filter);
      if (!(res && res.status && res.status !== 200)) {
        const formsCategories = getFormsCategories(res.result);

        if (res.result.length > 0) {
          setFormsResponse({
            result: (res.result.filter((item) => item.categoryName === formsCategories[activeTab])),
            totalCount: res.totalCount
          });
        } else {
          setFormsResponse({
            result: [],
            totalCount: 0
          });
        }
      }
    } else
      setFormsResponse({ result: [], totalCount: 0 });
    setLoading(false);
  }, [filter, activeTab]);
  useEffect(() => {
    GetMyForms();
  }, [GetMyForms, filter.searchedItem]);
  const onTypeChanged = useCallback(
    (activeType) => {
      setActiveActionType(activeType);
    },
    [setActiveActionType]
  );

  const searchHandler = (event) => {
    setActiveTab(0);
    const { value } = event.target;
    setFilter((item) => ({ ...item, searchedItem: value }));
  };
  const onPageIndexChanged = (pageIndex) => {
    setFilter((item) => ({ ...item, pageIndex }));
  };
  const onPageSizeChanged = (pageSize) => {
    setFilter((item) => ({ ...item, pageIndex: 0, pageSize }));
  };
  const onTabChanged = (e, newTap) => {
    setActiveTab(newTap);
  };

  useEffect(() => {
    bottomBoxComponentUpdate(null);
  }, []);

  return (
    <div className='view-wrapper'>
      <Spinner isActive={loading} />
      <div className='header-section'>
        <div className='filter-section px-2'>
          <div className='section'>
            <Button className='btns theme-solid bg-primary' onClick={() => setOpenAddNewForm(true)}>
              {t('AddForm')}
            </Button>
          </div>

          <div className='section px-2'>
            <PermissionsComponent
              permissionsList={Object.values(FormBuilderPermissions)}
              permissionsId={FormBuilderPermissions.ViewFormBuilder.permissionsId}
            >
              <Inputs
                idRef='usersSearchRef'
                variant='outlined'
                onInputChanged={searchHandler}
                fieldClasses='inputs theme-solid'
                value={filter.searchedItem}
                label={t('SearchForm')}
                beforeIconClasses='mdi mdi-magnify mdi-24px c-gray-primary'
              // onKeyUp={searchHandler}
              />

              <ViewTypes
                onTypeChanged={onTypeChanged}
                activeTypes={[ViewTypesEnum.tableView.key, ViewTypesEnum.cards.key]}
                className='mb-3'
              />
            </PermissionsComponent>
          </div>
        </div>
      </div>
      <PermissionsComponent
        permissionsList={Object.values(FormBuilderPermissions)}
        permissionsId={FormBuilderPermissions.ViewFormBuilder.permissionsId}
      >
        <div className='w-100 px-3 mt-3 mb-3'>
          <TabsComponent
            data={formsCategoryTabs}
            labelInput='label'
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            themeClasses='theme-solid'
            currentTab={activeTab}
            onTabChanged={onTabChanged}
          />
        </div>
        {(
          activeActionType === ViewTypesEnum.tableView.key) ? (
            <FormBuilderListView
              formsResponse={formsResponse}
              page={filter.pageIndex}
              setPage={onPageIndexChanged}
              rowsPerPage={filter.pageSize}
              setRowsPerPage={onPageSizeChanged}
              reloadData={() => GetMyForms()}
              loginResponse={loginResponse}
            />
        ) : (
          <FormBuilderGridView
            formsResponse={formsResponse}
            reloadData={() => GetMyForms()}
            loginResponse={loginResponse}
          />
        )}
        {openAddNewForm && (
          <AddNewFormDialog
            isOpen={openAddNewForm}
            setOpenAddNewForm={setOpenAddNewForm}
            formsCategoryTabs={formsCategoryTabs}
            reloadData={() => {
              setOpenAddNewForm(false);
              GetMyForms();
            }}
            translationPath={translationPath}
            parentTranslationPath={parentTranslationPath}
          />
        )}
      </PermissionsComponent>
    </div>
  );
};
const mapStateToProps = (state) => {
  const {
    login: { loginResponse },
  } = state;
  return {
    loginResponse,
  };
};

const view = connect(mapStateToProps)(PickFormBuilder);
export { view as PickFormBuilder };
